// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609071204/js/" + chunkId + "." + {"44":"ec1f3c21","225":"de4484d9","481":"3b2f542e","486":"041e88fb","770":"ca1dde21"}[chunkId] + ".0.7709065497422956.chunk.js";
};